// Zentrale Produkt-Strings für Bestellungen.
// Die Strings landen 1:1 komma-getrennt in wtb_bestellungen.bestell_produkt_text (varchar 250).
// Regeln: kein Komma innerhalb eines Strings; Aufsteller-Strings müssen "Aufsteller" enthalten
// (Downstream-Systeme matchen per LIKE '%Aufsteller%').
export const PRODUCT_KEYS = Object.freeze({
  PACKAGE: 'WaizmannTabelle Komplettpaket (Erwachsene + 60plus + KFO/Kind)',
  ADULT: 'WaizmannTabelle Erwachsene',
  SENIOR: 'WaizmannTabelle 60plus',
  KIDS: 'WaizmannTabelle KFO/Kind',
  PZR: 'WaizmannTabelle Prophylaxe PZR',
  STAND_TRIPLE: 'Design-Aufsteller 3-fach',
  STAND_KIDS: 'Design-Aufsteller KFO/Kind',
  STAND_PZR: 'Design-Aufsteller Prophylaxe',
  GESAMT: 'WaizmannTabelle Gesamtausgabe',
});

// Die drei Tabellen, die zusammen das Komplettpaket bilden.
export const PACKAGE_MEMBERS = Object.freeze([
  PRODUCT_KEYS.ADULT,
  PRODUCT_KEYS.SENIOR,
  PRODUCT_KEYS.KIDS,
]);

// Feste Reihenfolge im Produkttext und in den Chips.
export const PRODUCT_ORDER = Object.freeze(Object.values(PRODUCT_KEYS));
